/**
 * What picking a what3words address in the Explore search does: on the map
 * or the planner, fly the map to its square, close enough to see it; anywhere
 * else, open the map at it.
 */
export type W3wMapAction =
  | { kind: 'fly'; center: [number, number]; zoom: number }
  | { kind: 'navigate'; url: string };

/** A square is 3 m across — zoomed in far enough that the walker sees which field it's in. */
export const W3W_ZOOM = 17;

export function w3wMapAction(
  location: { lng: number; lat: number },
  page: { hasMap: boolean; pathname: string }
): W3wMapAction {
  const onMapPage = page.pathname === '/map' || page.pathname.startsWith('/hike-planner');
  if (page.hasMap && onMapPage) return { kind: 'fly', center: [location.lng, location.lat], zoom: W3W_ZOOM };
  return { kind: 'navigate', url: `/map?lat=${location.lat}&lng=${location.lng}` };
}
